/* eslint import/no-unresolved: 0 */
// @ts-ignore
import version from './version';
export default version;


//////////////////
// WEBPACK FOOTER
// ../node_modules/antd/es/version/index.js
// module id = 3186
// module chunks = 0